import React, { useState, useEffect } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import {Typography, Button, Row, Col, Card, Space, Divider, Tooltip, Image, Avatar, Descriptions, Switch, Spin} from "antd";
import {RollbackOutlined, EditOutlined, UserAddOutlined, ReloadOutlined, UserOutlined, DollarOutlined } from "@ant-design/icons";
import Pageloader from "../../../components/loader";
import { useNavigate } from "react-router-dom";
import { DummyPermissionReturnPickupHelper, taskButtonStatuses, userhasPermissionHelper } from "../../../utils/Helpers";
// import { getOrderManagementDetail } from "../../../services/orderManagement.service";
import ModalAssignOrder from "./components/modal/modalAssignOrder";
import ModalEditOrder from "./components/modal/modalEditOrder";
import ModalReturnPickupOrders from "./components/modal/modalReturnPickupOrders";
import ModalReassignOrder from "./components/modal/modalReassignOrder";
import ModalUnassignOrder from "./components/modal/modalUnassignOrder";
import OrderComplete from "./components/modal/OrderComplete";
import OrderCancel from "./components/modal/OrderCancel";
import OrderCancelConfirmation from "./components/modal/OrderCancelConfirmation";
import ModalEditOrderRider from "./components/modal/modalEditOrderRider";
import ModalTaskIssueCreate from "./components/modal/modalTaskIssueCreate";
import OrderItemNotShipped from "./components/modal/orderItemNotShipped";
import InvoiceDetails from "./components/modal/invoiceDetails";

import RiderLists from "./components/riderLists";
import RiderStatusLists from "./components/riderStatusLists";
import OrderTotlesLists from "./components/orderTotlesLists";
import OrderPickNDrop from "./components/orderPickNDrop";
import DispactherNoteOrder from "./components/orderDispactherNote";
import OrderDeliveriesTable from "./components/deliveriesTable";
// import OrderRoutesTable from "./components/routesTable";
import OrderIssueTable from "./components/orderIssueTable";
import OrderDetailProductTable from "./components/orderDetailProductTable";
import OrderAssignmentRequests from "./components/orderAssignmentRequests";
import OrderAssignStory from "./components/orderAssignStory";
import OrderIssueRequests from "./components/orderIssueRequests";
// import OrderAssignmentRequests from "./components/orderAssignmentRequests";

import * as orderManagementActions from "../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
import moment from "moment";
import GreenCircleIcon from "../../../components/svgs/indrive_icon";
import OrderCancelChargeToRider from "./components/modal/OrderCancelChargeToRider/OrderCancelChargeToRider";

const { Text, Title } = Typography;
const OverviewView = (props) => {
  const params = useParams();
  const { overviewdashboardid } = params;
  const navigate = useNavigate();
  const [postDataOrderView, setPostDataOrderView] = useState(null);
  const [postDataOrderViewtwice, setPostDataOrderViewtwice] = useState(null);
  const [postDataOrderRiderID, setPostDataOrderRiderID] = useState(null);
  const [postDataOrderRiderMongoID, setPostDataOrderRiderMongoID] = useState(null);
  const [loading, setLoading] = useState(true);
  const [OrderId, setOrderId] = useState(0);
  const [jobTypeDeliveryStatus, setJobTypeDeliveryStatus] = useState(false);
  const [cancelOrderFreezSwitch, setCancelOrderFreezSwitch] = useState(false);
  const [cancelOrderRemoveFromRiderSwitch, setCancelOrderRemoveFromRiderSwitch] = useState(false);
  const [loadingcancelOrderFreezSwitch, setLoadingcancelOrderFreezSwitch] = useState(false);

  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    // setLoading(true);
    postListsrefresh();
  };
  useEffect(() => {
    if(typeof props.orderCancelConfirmationData.data != "undefined" && props.orderCancelConfirmationData.data.confirmationCancel === true){
      showOrderCancelConfirmationModal()
    }
  }, [props.orderCancelConfirmationData]);
  const postListsrefresh = async () => {
    try {
      await props.orderManagementActions.getOrderManagementDetailAction(overviewdashboardid);
    } catch (e) {} finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props.taskDetailData) {
      setPostDataOrderViewtwice(props.taskDetailData);
      checkDataStatus(props.taskDetailData);
      const jobTypePickup = "pickup";
      const jobTypeDelivery = "delivery";
      props.taskDetailData.map((item) => {
        if (item.store) setOrderId(item.store.storeId);
        if (jobTypeDeliveryStatus === true) {
          if (item.job_type === jobTypePickup) {
            // console.log("order if", props.taskDetailData, item);
            return setPostDataOrderView(item), setPostDataOrderRiderID(item.rider), setPostDataOrderRiderMongoID(item.rider.id);
          }
        } else {
          if (item.job_type === jobTypeDelivery) {
            // console.log("order else", props.taskDetailData, item);
            return setPostDataOrderView(item), setPostDataOrderRiderID(item.rider), setPostDataOrderRiderMongoID(item.rider.id);
          }
        }
      });
    }
  }, [props.taskDetailData]);

  useEffect(() => {
    if(postDataOrderView) {
      setCancelOrderFreezSwitch(postDataOrderView?.canceled_return_status_log?.freez)
      setCancelOrderRemoveFromRiderSwitch(postDataOrderView?.canceled_return_status_log?.remove_from_rider)
    }
  }, [postDataOrderView]);

  const checkDataStatus = (values) => {
    const jobTypePickup = "pickup";
    const statusCurrent = "completed";
    values.map((item) => {
      if (item.job_type === jobTypePickup) {
        item.status.map((itemStatus) => {
          if (itemStatus.current === true && itemStatus.slug != statusCurrent) {
            return setJobTypeDeliveryStatus(true);
          } else {
            return setJobTypeDeliveryStatus(false);
          }
        });
      }
    });
  };

  const checkDataStatusPickupSuccessful = (values) => {
    const data = values && values.find((item)=>{
      if(item.job_type == "delivery") {
        return true;
      }
    });
    const result = data && data.status.find((d)=>d.current == true && d.slug === "completed");
    return result == undefined?true:false;
  }


  // const OrderProductdetail = (value) => {
  //   setPostDataOrderRiderID(value.rider);
  // };

  // Order Edit Modal
  const [showModalOrderEdit, setshowModalOrderEdit] = useState(false);
  const showOrderEditModal = () => {
    setshowModalOrderEdit(true);
  };
  // Return Pickup Orders Modal
  const [showModalReturnPickupOrders, setshowModalReturnPickupOrders] = useState(false);
  const showReturnPickupOrdersModal = () => {
    setshowModalReturnPickupOrders(true);
  };
  // Order Return Pickup Orders Modal
  const [showModalOrderRider, setshowModalOrderRider] = useState(false);
  const showOrderRiderModal = () => {
    setshowModalOrderRider(true);
  };
  // Order Reassign Modal
  const [showModalOrderReassign, setshowModalOrderReassign] = useState(false);
  const showOrderReassignModal = () => {
    setshowModalOrderReassign(true);
  };
  // Order Unassign Modal
  const [showModalOrderUnassign, setshowModalOrderUnassign] = useState(false);
  const showOrderUnassignModal = () => {
    setshowModalOrderUnassign(true);
  };
  // Order Assign Modal
  const [showModalOrderAssign, setshowModalOrderAssign] = useState(false);
  const showOrderAssignModal = () => {
    setshowModalOrderAssign(true);
  };
  // Order Complete Modal
  const [showModalOrderComplete, setshowModalOrderComplete] = useState(false);
  const showOrderCompleteModal = () => {
    setshowModalOrderComplete(true);
  };
  // Order Cancel Modal
  const [showModalOrderCancel, setshowModalOrderCancel] = useState(false);
  const showOrderCancelModal = () => {
    setshowModalOrderCancel(true);
  };
  // Order Cancel charge to rider
  const [showModalOrderCancelChargeToRider, setshowModalOrderCancelChargeToRider] = useState(false);
  const OrderCancelChargeToRiderAction = () => {
    setshowModalOrderCancelChargeToRider(true);
  };
  // Order Cancel Confirmation Modal
  const [showOrderCancelConfirmation, setshowOrderCancelConfirmation] = useState(false);
  const showOrderCancelConfirmationModal = () => {
    setshowOrderCancelConfirmation(true);
  };
  // Order Issue Create Modal
  const [showModalCreateIssue, setshowModalCreateIssue] = useState(false);
  const showOrderCreateTaskIssue = () => {
    setshowModalCreateIssue(true);
  };
  // Order Item Isn't Shipped
  const [showModalOrderItemNotShipped, setshowModalOrderItemNotShipped] = useState(false);
  const showOrderItemNotShipped = () => {
    setshowModalOrderItemNotShipped(true);
  };

  const [showModalInvoiceDetails, setshowModalInvoiceDetails] = useState(false);
  const showInvoiceDetails= () => {
    setshowModalInvoiceDetails(true);
  };

  const freezSwitchHandleChange= async (e, type) => {
    setLoadingcancelOrderFreezSwitch(true);
    setCancelOrderFreezSwitch(e);
    try {
      await props.orderManagementActions.UpdateCancelOrderReturnLockAction({type: type, value: e, order_id: overviewdashboardid});
    } catch (e) {} finally {
      setLoadingcancelOrderFreezSwitch(false);
    }
  };

  const RemoveFromRiderSwitchHandleChange= async (e, type) => {
    setLoadingcancelOrderFreezSwitch(true);
    setCancelOrderRemoveFromRiderSwitch(e);
    try {
      await props.orderManagementActions.UpdateCancelOrderReturnLockAction({type: type, value: e, order_id: overviewdashboardid});
    } catch (e) {} finally {
      setLoadingcancelOrderFreezSwitch(false);
    }
  };

  return loading ? (
    <div className="page-content"><Pageloader /></div>
  ) : (
    <div className="page-content">
      <ModalAssignOrder
        visible={showModalOrderAssign}
        setvisible={setshowModalOrderAssign}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
        overviewdashboardid={overviewdashboardid}
        OrderId={OrderId}
      />
      <ModalReassignOrder
        visible={showModalOrderReassign}
        setvisible={setshowModalOrderReassign}
        orderRiderID={postDataOrderRiderID}
        postListsrefresh={postListsrefresh}
        storeId={OrderId}
        OrderId={overviewdashboardid}
      />
      <ModalUnassignOrder
        visible={showModalOrderUnassign}
        setvisible={setshowModalOrderUnassign}
        orderRiderID={postDataOrderRiderID}
        postListsrefresh={postListsrefresh}
        // storeId={OrderId}
        OrderId={overviewdashboardid}
        agentUser={props.emailUser}
      />
      <OrderComplete
        OrderId={OrderId}
        visible={showModalOrderComplete}
        setvisible={setshowModalOrderComplete}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
        overviewdashboardid={overviewdashboardid}
      />
      <OrderCancel
        visible={showModalOrderCancel}
        setvisible={setshowModalOrderCancel}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
        overviewdashboardid={overviewdashboardid}
      />
      <OrderCancelChargeToRider
        visible={showModalOrderCancelChargeToRider}
        setvisible={setshowModalOrderCancelChargeToRider}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
        overviewdashboardid={overviewdashboardid}
      />
      <OrderCancelConfirmation
          visible={showOrderCancelConfirmation}
          setvisible={setshowOrderCancelConfirmation}
          orderData={postDataOrderViewtwice}
          postListsrefresh={postListsrefresh}
          overviewdashboardid={overviewdashboardid}
          orderCancelConfirmationData={props.orderCancelConfirmationData}
      />
      <ModalEditOrder
        visible={showModalOrderEdit}
        setvisible={setshowModalOrderEdit}
        // orderDataTask={postDataOrderView}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
      />
      <ModalReturnPickupOrders
        visible={showModalReturnPickupOrders}
        setvisible={setshowModalReturnPickupOrders}
        // orderDataTask={postDataOrderView}
        orderData={postDataOrderViewtwice}
        postListsrefresh={postListsrefresh}
      />
      <ModalEditOrderRider
        visible={showModalOrderRider}
        setvisible={setshowModalOrderRider}
        // orderData={postDataOrderView}
        orderRiderID={postDataOrderRiderMongoID}
      />
      <ModalTaskIssueCreate
        visible={showModalCreateIssue}
        setvisible={setshowModalCreateIssue}
        taskid={overviewdashboardid}
        postListsrefresh={postListsrefresh}
      />
      <OrderItemNotShipped
        visible={showModalOrderItemNotShipped}
        setvisible={setshowModalOrderItemNotShipped}
        orderData={postDataOrderViewtwice}
      />
      <InvoiceDetails
        visible={showModalInvoiceDetails}
        setvisible={setshowModalInvoiceDetails}
        orderData={postDataOrderViewtwice}
      />
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>Order #{overviewdashboardid} </Title>
          {postDataOrderView?.device_type == "indrive" ? <GreenCircleIcon width={26} height={26} /> : "" }
        </div>
        <div className="pch-content">
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_UNFREEZE) ?
            <Text>
              <strong>Freez: </strong> 
              <Spin spinning={loadingcancelOrderFreezSwitch}>
                <Switch checked={cancelOrderFreezSwitch} onChange={(e)=>freezSwitchHandleChange(e,"freez")} />
              </Spin>
            </Text>
          :
            ""
          }
          <Text>
            <strong>Remove from rider: </strong> 
            <Spin spinning={loadingcancelOrderFreezSwitch}>
              <Switch checked={cancelOrderRemoveFromRiderSwitch} onChange={(e)=>RemoveFromRiderSwitchHandleChange(e,"remove_from_rider")} />
            </Spin>
          </Text>
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CHARGE_TO_RIDER) ?
            <Tooltip title="Charge To Rider">
              <Button 
              disabled={postDataOrderView?.charge_to_rider?.charge_to_rider_status} 
              onClick={OrderCancelChargeToRiderAction}><DollarOutlined /></Button>
            </Tooltip>
            :
            ""
          } 
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_MANUAL_ASSIGN) ?
            <Tooltip title="Assign Rider">
              <Button disabled={taskButtonStatuses(postDataOrderViewtwice)} onClick={showOrderAssignModal}>
                <UserAddOutlined />
              </Button>
            </Tooltip>             
            :
            ""
          }
          <Tooltip title="Edit Task">
            <Button disabled={taskButtonStatuses(postDataOrderViewtwice)} onClick={showOrderEditModal}>
              <EditOutlined />
            </Button>
          </Tooltip>
          {/* {DummyPermissionReturnPickupHelper(props.emailUser.email) && */}
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RETURN_PICKUP_ORDER) &&
            <Tooltip title="Create Return Pickup Order">
              <Button
                disabled={checkDataStatusPickupSuccessful(postDataOrderViewtwice)}
                onClick={showReturnPickupOrdersModal}
              >
                <ReloadOutlined />
              </Button>
            </Tooltip>
          }
          {/* {userEmailAllow(props.emailUser.email)?<Tooltip title="Cancel Task">
            <Button onClick={showOrderCancelModal}><CloseOutlined /></Button>
          </Tooltip>:<Tooltip title="Cancel Task">
            <Button disabled={taskButtonStatuses(postDataOrderViewtwice)} onClick={showOrderCancelModal}><CloseOutlined /></Button>
          </Tooltip>} */}
          <Tooltip title="Go Back">
            <Button onClick={() => navigate("/overview")}>
              <RollbackOutlined />
            </Button>
          </Tooltip>
        </div>
      </div>
      <div className="p-content">
        <Row>
          <Col span={16}>
            <RiderLists orderData={postDataOrderViewtwice} showOrderRiderModal={showOrderRiderModal} showOrderItemNotShipped={showOrderItemNotShipped} showInvoiceDetails={showInvoiceDetails} />
            {/* picker packer details */}
            <Descriptions style={{ marginBottom: "35px" }} className="listLabelBold">
              <Descriptions.Item label="Picture Packed Time Packmate" span={3}>
                {
                  postDataOrderView?.order_details?.picker_packer?.packer_time ? 
                    moment(postDataOrderView?.order_details?.picker_packer?.packer_time).format("DD MMMM, yyyy, h:mm A") 
                      : 
                    "-"
                  }
              </Descriptions.Item>
              <Descriptions.Item label="Picture Packed Time" span={3}>
                {
                  postDataOrderView?.order_details?.picker_packer?.packer_upload_image_time ? moment(postDataOrderView?.order_details?.picker_packer?.packer_upload_image_time).format("DD MMMM, yyyy, h:mm A") : "-"
                }
              </Descriptions.Item>
              <Descriptions.Item label="Packer ID  " span={3}>
                {postDataOrderView?.order_details?.picker_packer?.packer_id?.display_id ? postDataOrderView?.order_details?.picker_packer?.packer_id?.display_id : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Packer User Name" span={3}>
                {postDataOrderView?.order_details?.picker_packer?.packer_id?.fullName ? postDataOrderView?.order_details?.picker_packer?.packer_id?.fullName : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Picture Packed" span={3}>
                { 
                  postDataOrderView?.order_details?.picker_packer?.packer_image 
                    && 
                  <Image alt="Picture Packed Time" src={postDataOrderView?.order_details?.picker_packer?.packer_image} /> 
                }
              </Descriptions.Item>
            </Descriptions>
            
            <RiderStatusLists orderData={postDataOrderView} />
          </Col>
          <Col span={8}>
            <Space direction="vertical" style={{ width:"100%", gap:"16px" }}>
              <OrderPickNDrop orderData={postDataOrderViewtwice} />
              {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_DISPATCHER_NOTES) &&
                <DispactherNoteOrder orderData={postDataOrderViewtwice} pageorderid={overviewdashboardid} postListsrefresh={postListsrefresh} />
              }
            </Space>
          </Col>
        </Row>
        <Divider />
        <Space direction="vertical" style={{ width: "100%" }}>
          {postDataOrderView && postDataOrderView.issues === null ? "":
            <Card title="Issues" bordered extra={<Button onClick={showOrderCreateTaskIssue}>Create Issue</Button>}>
              <OrderIssueTable OrderID={overviewdashboardid} />
            </Card>
          }
          <OrderDeliveriesTable
            orderData={postDataOrderView}
            orderDatatwice={postDataOrderViewtwice}
            showOrderRiderModal={showOrderRiderModal}
            showOrderReassignModal={showOrderReassignModal}
            showOrderUnassignModal={showOrderUnassignModal}
            showOrderCompleteModal={showOrderCompleteModal}
            showOrderCancelModal={showOrderCancelModal}
            showOrderCancelConfirmationModal={showOrderCancelConfirmationModal}
          />
          <OrderAssignStory pageorderid={overviewdashboardid} />
          <OrderAssignmentRequests pageorderid={overviewdashboardid} />
          <OrderIssueRequests pageorderid={overviewdashboardid} />

          {/* <Card title="Routes" bordered>
            <OrderRoutesTable
              orderData={postDataOrderView}
              showOrderRiderModal={showOrderRiderModal}
            />
          </Card> */}
          <Card title="Order items" bordered>
            <OrderDetailProductTable orderData={postDataOrderViewtwice} />
          </Card>
          <Card className="total-payment" bordered>
            <OrderTotlesLists orderData={postDataOrderViewtwice} />
          </Card>
          {/* <Card bordered>
            <OrderAssignmentRequests pageorderid={overviewdashboardid} />
          </Card> */}
        </Space>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    taskDetailData: state.OrderManagementReducer.taskDetailData,
    emailUser: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
    orderCancelConfirmationData: state.OrderManagementReducer.orderCancelConfirmationData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OverviewView);
